/* @flow weak */
/**
 *
 * DEPRECATED! Use 'components/lib/chainOnEnter' instead of using a mixin.
 *
 * This enables the use of multiple mixins that provide static `onEnter` methods to be
 * used with `react-router` views.
 *
 * This is used by providing an array of mixins like so:
 *
 *   mixins: [
 *     chainOnEnter([RequireUser, RequireDesktop])
 *   ]
 *
 * The order matters. chainOnEnter will skip any remaining onEnters once replaceWith is called.
 *
 * You must specify the onEnter method in the route definition, or it will never get called:
 *
 *   <Route
 *     path="/chat/leave/:token"
 *     component={LeaveChatView}
 *     onEnter={LeaveChatView.onEnter}
 *    />
 */

import chainOnEnter from 'components/lib/chainOnEnter';

const chainOnEnterMixin = function(mixins) {
  return {
    statics: {
      onEnter: chainOnEnter(mixins),
    },
  };
};

export default chainOnEnterMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/chainOnEnter.js